var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGefionFacility2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 76,
    viewBox: "0 0 80 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M75 35.0545V11.6797C75 5.23953 69.7605 0 63.3203 0H16.3672C9.92703 0 4.6875 5.23953 4.6875 11.6797V35.2809C1.84219 37.4369 0 40.8506 0 44.6875V75.0781H14.0625V65.8594H65.9375V75.0781H80V44.6875C80 40.7123 78.0217 37.1928 75 35.0545ZM4.6875 56.3281H75.3125V61.1719H4.6875V56.3281ZM37.5 32.8906H14.0625V31.7188C14.0625 29.1341 16.1653 27.0312 18.75 27.0312H32.8125C35.3972 27.0312 37.5 29.1341 37.5 31.7188V32.8906ZM65.625 32.8906H42.1875V31.7188C42.1875 29.1341 44.2903 27.0312 46.875 27.0312H60.9375C63.5222 27.0312 65.625 29.1341 65.625 31.7188V32.8906ZM9.375 11.6797C9.375 7.82422 12.5117 4.6875 16.3672 4.6875H63.3203C67.1758 4.6875 70.3125 7.82422 70.3125 11.6797V31.7188C70.3125 26.5494 66.1069 22.3438 60.9375 22.3438H46.875C44.0769 22.3438 41.563 23.5775 39.8438 25.5277C38.1245 23.5775 35.6106 22.3438 32.8125 22.3438H18.75C13.5806 22.3438 9.375 26.5494 9.375 31.7188V11.6797ZM11.7969 37.5781H68.2031C72.1233 37.5781 75.3125 40.7673 75.3125 44.6875V51.6406H4.6875V44.6875C4.6875 40.7673 7.87672 37.5781 11.7969 37.5781ZM9.375 70.3906H4.6875V65.8594H9.375V70.3906ZM75.3125 70.3906H70.625V65.8594H75.3125V70.3906Z",
    fill: "#C49A36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGefionFacility2);
export default __webpack_public_path__ + "static/media/gefion-facility-2.19bcb523.svg";
export { ForwardRef as ReactComponent };